var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M48.88 8h-1.76a8 8 0 0 0-8 8v.72a8 8 0 0 1-4 6.92l-1.72 1a8 8 0 0 1-8 0l-.6-.32a8 8 0 0 0-10.92 2.92L13 28.76a8 8 0 0 0 2.92 10.92l.6.4a8 8 0 0 1 4 6.88V49a8 8 0 0 1-4 6.96l-.6.36A8 8 0 0 0 13 67.24l.88 1.52a8 8 0 0 0 10.92 2.92l.6-.32a8 8 0 0 1 8 0l1.72 1a8 8 0 0 1 4 6.92V80a8 8 0 0 0 8 8h1.76a8 8 0 0 0 8-8v-.72a8 8 0 0 1 4-6.92l1.72-1a8 8 0 0 1 8 0l.6.32a8 8 0 0 0 10.92-2.92L83 67.2a8 8 0 0 0-2.92-10.92l-.6-.32a8 8 0 0 1-4-6.96v-2a8 8 0 0 1 4-6.96l.6-.36A8 8 0 0 0 83 28.76l-.88-1.52a8 8 0 0 0-10.92-2.92l-.6.32a8 8 0 0 1-8 0l-1.72-1a8 8 0 0 1-4-6.92V16a8 8 0 0 0-8-8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M48 60c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12"
  })));
};
export default SvgSettings;